export const accountTableFields = {
  GO_SEARCH_RESPONSE_ROW_ID: 'goSearchResponseRowId',
  EECS_GO_ID: 'id',
  PRODUCTION_DEVICE_CODE: 'productionDeviceCode',
  QUANTITY: 'quantity',
  MAX_QUANTITY: 'maxQuantity',
  PRODUCTION_TIME: 'issueDate',
  CONSUMPTION_TIME: 'consumptionDate',
  EXPIRATION_TIME: 'expirationDate',
  TRANSFER_DEADLINE: 'transferDeadline',
  TRANSFER_DEADLINE_PASSED: 'transferDeadlinePassed',
  TECHNOLOGY: 'technologyType',
  HYDROGEN_TECHNOLOGY: 'hydrogenTechnologyType',
  HYDROGEN_FUEL_TYPE: 'hydrogenFuelType',
  FUEL_TYPE: 'fuelType',
  GAS_TYPE: 'gasType',
  FEEDSTOCK: 'feedstock',
  BIOFUEL_TYPE: 'biofuelType',
  PRODUCTION_PATHWAY: 'productionPathway',
  SUSTAINABLE_BIOFUEL: 'sustainableBiofuel',
  GOS_COST: 'gosCost',
  GOS_PRICE: 'gosPrice',
};

export const eecsGoTableFields = {
  ID: 'id',
  GAS_TYPE: 'gasType',
  PRODUCTION_PERIOD: 'productionPeriod',
  TRANSFER_DEADLINE: 'transferDeadline',
  EXPIRATION_TIME: 'dateOfExpiration',
  COUNTRY: 'countryOfIssue',
  PRODUCTION_TECHNOLOGY: 'productionTechnology',
  FEEDSTOCK: 'energySource',
  PRODUCTION_SUPPORT: 'productionSupport',
  INVESTMENT_SUPPORT: 'investmentSupport',
  QUANTITY: 'quantity',
  DEVICE_EECS_CODE: 'deviceEecsCode',
  FUEL_TYPE: 'fuelTypeClassifier',
  MAX_QUANTITY: 'maxQuantity',
};

export const accountReportTableFields = {
  TECHNOLOGY: 'technologyType',
  FUEL_TYPE: 'fuelType',
  HYDROGEN_TYPE: 'hydrogenType',
  EICW_CODE: 'eicwCode',
  CANCELLED_GO: 'cancelledGos',
  END_BALANCE: 'endBalance',
  ENTERED_SET: 'enteredTransferGoSet',
  EXPIRED_SET: 'expiredGoSet',
  ISSUED_GO: 'issuedGos',
  START_BALANCE: 'startBalance',
  TRANSFERRED_GO: 'transferredGos',
};
